module.exports = "/assets/fdb89dc0484b39409355b70edc2d00d1.svg";